module.exports = __webpack_public_path__ + "img/provider_11.95e4f0eb.png";